module.exports = __webpack_public_path__ + "img/rich.f64d398d.png";